import { AuthState } from "./types";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "store/rootReducer";
import { API_URL } from "config";
import { setResponseMessage } from "features/admin/adminSlice";
import { batch } from "react-redux";
import userStorage from "store/UserStorage";
const initialState: AuthState = {
  isLoading: false,
  loginLoading: false,
  loginError: null,
};

const auth = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    loginStart(state) {
      state.loginLoading = true;
      state.isLoading = true;
      state.loginError = null;
    },
    loginSuccess(state) {
      state.loginLoading = false;
      state.isLoading = false;
      state.loginError = null;
    },
    loginError(state, action) {
      state.loginLoading = false;
      state.loginError = action.payload;
      state.isLoading = false;
    },

    setPreloader(state, action) {
      state.isLoading = action.payload;
    },
  },
});
export const {
  loginStart,
  loginSuccess,
  loginError,
  setPreloader,
} = auth.actions;
export const selectPreloader = (state: RootState) => state.auth.isLoading;
export const selectLoginLoading = (state: RootState) => state.auth.loginLoading;
export const selectLoginError = (state: RootState) => state.auth.loginError;

export const signIn = (
  username: string,
  password: string,
  callback: () => void
) => async (dispatch: any) => {
  try {
    dispatch(loginStart());

    let formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);
    const response = await axios.post(`${API_URL}/auth`, {
      username,
      password,
    });
    if (response.status === 200) {
      userStorage.setUser(response.data.token);
      batch(() => {
        dispatch(
          setResponseMessage({ message: "Добре дошли", hasError: false })
        );
        dispatch(loginSuccess());
      });
      callback();
      window.location.reload();
    } else {
      const errorMsg =
        response.status === 400 || response.status === 401
          ? "Грешем потребител или парола."
          : "Неуспешен опит за вход, моля опитайте отново.";
      dispatch(loginError(errorMsg));
    }
  } catch (error: any) {
    console.log(error);
    dispatch(loginError("Неуспешен опит за вход, моля опитайте отново."));
  }
};

export const signOut = (callback?: any) => async (dispatch: any) => {
  dispatch(setPreloader(true));
  userStorage.logout();
  dispatch(setPreloader(false));
  callback && callback();
  window.location.reload();
};

export default auth.reducer;
